module.exports = __webpack_public_path__ + "img/worldmap.0a916475.svg";